export type ImageModelCode =
  | 'doubao-seedream-5-0-260128'
  | 'gemini-3.1-flash-image'
  | 'gpt-image-2'
  | 'gpt-image-2.5-sunburst';

export const DEFAULT_IMAGE_MODEL_CODE: ImageModelCode = 'gpt-image-2';

export type ImageTranslationModelCode = Exclude<
  ImageModelCode,
  'doubao-seedream-5-0-260128'
>;

export interface ImageModelSpec {
  name: string;
}

/**
 * 各个模型的需求规格
 */
export const imageModelSpecs = new Map<ImageModelCode, ImageModelSpec>();

imageModelSpecs.set('gpt-image-2', {
  name: 'GPT Image 2',
});

imageModelSpecs.set('gpt-image-2.5-sunburst', {
  name: 'GPT Image 2.5',
});

imageModelSpecs.set('gemini-3.1-flash-image', {
  name: 'Nano Banana',
});

imageModelSpecs.set('doubao-seedream-5-0-260128', {
  name: 'Seedream 5.0',
});

export const imageTranslationModelSpecs = new Map(
  Array.from(imageModelSpecs).filter(
    (entry): entry is [ImageTranslationModelCode, ImageModelSpec] =>
      entry[0] !== 'doubao-seedream-5-0-260128',
  ),
);

export const imageModelNameMap = new Map(
  imageModelSpecs.entries().map(([code, spec]) => [code, spec.name]),
);

export function getImageModelName(code: string) {
  return imageModelNameMap.get(code as ImageModelCode) ?? code;
}
